<div class="fondo">
    <a routerLink="/" class="arrow"><i class="fas fa-arrow-left fa-2x"></i></a>
    <div class="row animate__animated animate__zoomIn animate__slow">
        <div class="col-7">
            <div class="login">
                <div>
                    <h3>Inicia Sesión</h3>
                </div>
                <form action="" [formGroup]="loginForm" (ngSubmit)="send()">
                    <div class="form__group field">
                        <input type="input" class="form__field" placeholder="Usuario" name="user" id='user' formControlName="usuario" required />
                        <label for="user" class="form__label">Usuario</label>
                    </div>
                    <div *ngIf="usuario.invalid && (usuario.dirty || usuario.touched)" class="alert alert-danger">
                        <div *ngIf="usuario.errors.required">
                            User is required.
                        </div>
                    </div>
                    <div class="form__group field">
                        <input type="password" class="form__field" placeholder="Contraseña" name="pass" id='pass' formControlName="psw" required />
                        <label for="pass" class="form__label">Contraseña</label>
                    </div>
                    <div *ngIf="psw.invalid && (psw.dirty || psw.touched)" class="alert alert-danger">
                        <div *ngIf="psw.errors.required">
                            Pass is required.
                        </div>
                    </div>
                    <div class="form__group field">
                        <input formControlName="recordarme" type="checkbox" name="remember" id="remember">
                        <label for="remember">Recordar Usuario</label>
                    </div>
                    <div class="cont-btn">
                        <button type="submit" class="login-btn" [disabled]="!loginForm.valid">Ingresar</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-5">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/login-anim.gif" alt="">
        </div>
    </div>
</div>